module.exports = __webpack_public_path__ + "static/media/31-9.e30def19.mp3";